<template>
  <div class="grid min-h-full grid-cols-1 grid-rows-[1fr,auto,1fr] bg-white lg:grid-cols-[max(50%,36rem),1fr] h-[100vh]">
    <header class="mx-auto w-full max-w-7xl px-6 pt-6 sm:pt-10 lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:px-8">
      <inertia-link href="/">
        <span class="sr-only">LIVCK.com</span>
        <img class="h-10 w-auto sm:h-12" :src="asset('img/branding/livck-logo-dark.svg')" alt="" />
      </inertia-link>
    </header>
    <main class="mx-auto w-full max-w-7xl px-6 py-24 sm:py-32 lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:px-8">
      <div class="max-w-lg">
        <p class="text-base font-semibold leading-8 text-primary-600">404</p>
        <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">{{ __('Page not found') }}</h1>
        <p class="mt-6 text-base leading-7 text-gray-600">{{ __('Sorry, we couldn’t find the page you’re looking for.') }}</p>
        <div class="mt-10">
          <inertia-link href="/" class="text-sm font-semibold leading-7 text-primary-600"><span aria-hidden="true">&larr;</span> {{ __('Back to homepage') }}</inertia-link>
        </div>
      </div>
    </main>
    <div class="hidden lg:relative lg:col-start-2 lg:row-start-1 lg:row-end-4 lg:flex lg:justify-center lg:items-center">
      <div class="bg-gray-900 h-full w-full flex items-center">
        <div class="m-auto">
          <img :src="asset('img/ServerIllustration.svg')" class="h-[37rem] w-auto" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fallback"
}
</script>